import { IndentValues } from "@/lib/utils/IndentValues";
import { Box, Indent, Txt } from "@stenajs-webui/core";
import { Icon, stenaIntermodal } from "@stenajs-webui/elements";
import { Tooltip } from "@stenajs-webui/tooltip";
import { isIntermodal } from "../lib/priceListValues";
import { PriceListRow } from "../types/PriceListRow";

interface Props {
  row: PriceListRow;
}

export const RouteCell = ({ row }: Props) => (
  <Box width={"calc(100% - 8px)"} overflow={"hidden"}>
    <Indent
      num={IndentValues.EIGHT}
      flexDirection={"row"}
      alignItems={"center"}
      gap={1}
    >
      <Txt
        overflow={"hidden"}
        textOverflow={"ellipsis"}
        whiteSpace={"nowrap"}
        style={{ minWidth: 0 }}
      >
        {row.route}
      </Txt>
      {isIntermodal(row) && (
        <Tooltip
          label={"Intermodal"}
          placement={"top"}
          appendTo={document.body}
        >
          <Icon
            icon={stenaIntermodal}
            size={12}
            data-testid={"price-list-intermodal-route"}
            aria-label={"Intermodal"}
          />
        </Tooltip>
      )}
    </Indent>
  </Box>
);
